export class GzzTelephone {

  Prefix: string;
  TelNumber: string;

  constructor(telephone) {

    if (telephone) {

      this.TelNumber = telephone.phoneNumber;

      if (telephone.prefix) {
        this.Prefix = telephone.prefix.text;
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/models/general/GzzTelephone.ts